import type { FC } from 'react';
import cn from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { ListItemContentProps } from '@wix/da-ds/pkg/List/ListItem/legos/ListItemContent';
import ListItemLink from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemLink';
import { Props as ListItemLinkProps } from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemLink/ListItemLink';
import ListItemButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemButton';
import { Props as ListItemButtonProps } from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemButton/ListItemButton';

import s from './StudioNavigationListItem.scss';

export interface Props extends ListItemContentProps {
  href?: ListItemLinkProps['href'];
  onClick?: ListItemButtonProps['onClick'];
  biData?: ListItemButtonProps['biData'] | ListItemLinkProps['biData'];
  className?: string;
}

const StudioNavigationListItem: FC<Props> = ({
  className,
  prefixIcon: PrefixIcon,
  label,
  isLabelBold,
  ...props
}) => {
  const ListItemComponent = getComponentClass(props);
  // note: lots of overriding. in the longer run, might want to separate
  // entirely from ListItem 6.1

  // we need to override ListItemContent's medium icons to be SMALLER
  const prefix = PrefixIcon ? (
    <PrefixIcon
      className={s['icon']}
      size={IconSize.SMALLER}
      disableDefaultColors={true}
    />
  ) : undefined;

  // todo: we have no way to update:
  //   - the gap used in ListItemContent

  return (
    <ListItemComponent
      className={cn(s['root'], isLabelBold && s['bold'], className)}
      prefix={prefix}
      // props.prefix can still override the above intentionally
      {...props}
      // we send in a node as label so we can override the color
      label={<div className={s['label']}>{label}</div>}
      isLabelBold={isLabelBold}
    />
  );
};
StudioNavigationListItem.displayName = 'StudioNavigationListItem';

export default StudioNavigationListItem;

function getComponentClass(props) {
  if (props.onClick) {
    return ListItemButton;
  }
  if (props.href) {
    return ListItemLink;
  }

  const propsJSON = JSON.stringify(props);
  throw new TypeError(
    `unknown StudioNavigationListItem component class:\n${propsJSON}`
  );
}
